(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nc-drop-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.customElements || customElements.get('nc-drop-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  class NcDropCountdown extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.target = Number(this.dataset.ts) * 1000;
      this.after = Math.max(0, Number(this.dataset.after) || 0) * 3600000;
      this.end = this.target + this.after;
      this.designMode = !!(window.Shopify && window.Shopify.designMode);

      // Only inside the window: before the drop, or within the hours after it. A page served later (for example
      // from cache) hides it.
      if (!this.target || (Date.now() >= this.end && !this.designMode)) {
        this.hideSection();
        return;
      }

      this.units = {};
      this.querySelectorAll('[data-u]').forEach((el) => { this.units[el.dataset.u] = el; });

      // Drop time in the visitor's own time zone
      var when = this.querySelector('[data-when]');
      try {
        var date = new Date(this.target);
        var day = date.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
        var time = date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
        when.textContent = day + ' at ' + time;
      } catch (e) { /* keep the store-time text */ }

      this.tick();
      this._i = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this._i);
      clearTimeout(this._t);
      this._ready = false;
    }

    hideSection() {
      var section = this.closest('.shopify-section');
      (section || this).style.display = 'none';
    }

    tick() {
      var r = Math.floor((this.target - Date.now()) / 1000);
      if (r <= 0) {
        clearInterval(this._i);
        this.goLive();
        return;
      }
      this.units.d.textContent = pad(Math.floor(r / 86400));
      this.units.h.textContent = pad(Math.floor((r % 86400) / 3600));
      this.units.m.textContent = pad(Math.floor((r % 3600) / 60));
      this.units.s.textContent = pad(r % 60);
    }

    goLive() {
      var eyebrow = this.querySelector('[data-eyebrow]');
      this.classList.add('is-live');
      this.querySelector('[data-timer]').hidden = true;
      this.querySelector('[data-live]').hidden = false;
      this.querySelector('[data-dot]').hidden = false;
      var pre = this.querySelector('[data-pre]');
      if (pre) pre.hidden = true;
      if (eyebrow && eyebrow.dataset.liveLabel) eyebrow.textContent = eyebrow.dataset.liveLabel;
      // With "Keep showing after the drop" set, hide again when that window ends on a page left open.
      if (this.after > 0 && !this.designMode) {
        clearTimeout(this._t);
        this._t = setTimeout(() => this.hideSection(), Math.max(0, this.end - Date.now()));
      }
    }
  }

  customElements.define('nc-drop-countdown', NcDropCountdown);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-drop-filter"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window.customElements || customElements.get('nc-drop-filter')) return;

  class NcDropFilter extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.param = this.dataset.param || 'filter.p.m.custom.model';
      try { this.claimed = JSON.parse(this.dataset.claimed || '[]').filter(Boolean); } catch (e) { this.claimed = []; }
      this.scroller = this.querySelector('.ncn__chips');
      this.chips = Array.prototype.slice.call(this.querySelectorAll('.ncn__chip'));
      this.chips.forEach((chip) => {
        try { chip._values = JSON.parse(chip.dataset.values || '[]').filter(Boolean); } catch (e) { chip._values = []; }
      });

      this.addEventListener('click', (event) => this.onClick(event));
      this._onReload = () => { this.classList.remove('is-loading'); this.sync(); };
      document.addEventListener('collection:reloaded', this._onReload);
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.sync(), { once: true });
      } else {
        this.sync();
      }

      if (this.scroller) {
        this.fade();
        this.scroller.addEventListener('scroll', () => this.fade(), { passive: true });
        this._onResize = () => this.fade();
        window.addEventListener('resize', this._onResize);
        var active = this.scroller.querySelector('.is-active, [aria-current]');
        if (active && this.scroller.scrollWidth > this.scroller.clientWidth) {
          this.scroller.scrollLeft = Math.max(0, active.offsetLeft - (this.scroller.clientWidth - active.offsetWidth) / 2);
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('collection:reloaded', this._onReload);
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      this._ready = false;
    }

    get form() {
      return document.querySelector('form[is="facet-form"]');
    }

    fade() {
      var el = this.scroller;
      var max = el.scrollWidth - el.clientWidth;
      el.classList.toggle('fade-l', max > 2 && el.scrollLeft > 2);
      el.classList.toggle('fade-r', max > 2 && el.scrollLeft < max - 2);
    }

    onClick(event) {
      var chip = event.target.closest('.ncn__chip');
      if (!chip || event.metaKey || event.ctrlKey || event.shiftKey) return;
      var form = this.form;
      if (!form || typeof form.renderSection !== 'function' || !window.theme || !theme.utils || !theme.utils.sectionId) return;
      event.preventDefault();

      var values = chip.classList.contains('is-active') ? [] : chip._values;
      var url = new URL(window.location.href);
      url.searchParams.delete(this.param);
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      values.forEach((v) => url.searchParams.append(this.param, v));
      url.searchParams.set('section_id', theme.utils.sectionId(form));

      this.classList.add('is-loading');
      form.renderSection(url.toString());
      this.sync();
    }

    sync() {
      var selected = new URL(window.location.href).searchParams.getAll(this.param);
      var claimed = this.claimed;
      var activeChip = null;

      if (selected.length) {
        this.chips.forEach((chip) => {
          if (activeChip || chip.hasAttribute('data-all')) return;
          var ok = selected.every((v) => chip.hasAttribute('data-rest') ? claimed.indexOf(v) === -1 : chip._values.indexOf(v) !== -1);
          if (ok) activeChip = chip;
        });
      }

      var counts = this.readCounts();
      this.chips.forEach((chip) => {
        var isAll = chip.hasAttribute('data-all');
        var on = isAll ? selected.length === 0 : chip === activeChip;
        chip.classList.toggle('is-active', on && !isAll);
        if (isAll && on) chip.setAttribute('aria-current', 'true'); else chip.removeAttribute('aria-current');
        chip.setAttribute('href', on && !isAll ? this.dataset.allHref : chip.dataset.href);

        var badge = chip.querySelector('[data-count]');
        if (badge && counts) {
          var n = chip._values.reduce((sum, v) => sum + (counts.byValue[v] || 0), 0);
          if (typeof n === 'number' && !isNaN(n)) {
            badge.textContent = n;
            chip.classList.toggle('is-empty', n === 0);
          }
        }
      });

      this.tidyTags(activeChip, selected.length);
    }

    // When a chip is active it already shows the Model selection (with its own x), so hide the
    // theme's per-model tags. Tags for other filters stay. Mixed selections show every tag.
    tidyTags(activeChip, selectedCount) {
      var param = this.param;
      document.querySelectorAll('.active-facets').forEach((box) => {
        var shown = 0;
        box.querySelectorAll('a[is="facet-remove"]:not(.facet-clear-all)').forEach((link) => {
          var row = link.closest('.removable-facet') || link;
          var hide = false;
          if (activeChip) {
            try {
              hide = new URL(link.getAttribute('href'), window.location.origin).searchParams.getAll(param).length < selectedCount;
            } catch (e) { hide = false; }
          }
          row.style.display = hide ? 'none' : '';
          if (!hide) shown += 1;
        });
        box.style.display = activeChip && shown === 0 ? 'none' : '';
      });
    }

    readCounts() {
      var byValue = {};
      var found = false;
      document.querySelectorAll('input[name="' + this.param + '"]').forEach((input) => {
        if (input.value in byValue) return;
        var label = input.id ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
        var m = label && label.textContent.match(/\((\d+)\)/);
        if (m) { byValue[input.value] = parseInt(m[1], 10); found = true; }
      });
      return found ? { byValue: byValue } : null;
    }
  }

  customElements.define('nc-drop-filter', NcDropFilter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nc-slider-navigator"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.customElements && customElements.get('nc-slider-nav')) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class NcSliderNav extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.btn = this.querySelector('.ncn__more');
      this.panel = this.querySelector('.ncn__panel');
      this.scrollers = Array.prototype.slice.call(this.querySelectorAll('.ncn__chips, .ncn__fams'));

      if (this.btn && this.panel) {
        if (!this.panel.hidden) this.classList.add('is-open');
        this.btn.addEventListener('click', () => this.toggle());
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.btn.getAttribute('aria-expanded') === 'true') {
            this.toggle(false);
            this.btn.focus();
          }
        });
      }

      this.scrollers.forEach((el) => {
        var current = el.querySelector('[aria-current], .is-active');
        if (current && el.scrollWidth > el.clientWidth) {
          var target = current.offsetLeft - (el.clientWidth - current.offsetWidth) / 2;
          el.style.scrollBehavior = 'auto';
          el.scrollLeft = Math.max(0, target);
          el.style.scrollBehavior = '';
        }
        this.fade(el);
        el.addEventListener('scroll', () => this.fade(el), { passive: true });
      });
      this._onResize = () => this.scrollers.forEach((el) => this.fade(el));
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      this._ready = false;
    }

    fade(el) {
      var max = el.scrollWidth - el.clientWidth;
      el.classList.toggle('fade-l', max > 2 && el.scrollLeft > 2);
      el.classList.toggle('fade-r', max > 2 && el.scrollLeft < max - 2);
    }

    toggle(force) {
      var p = this.panel;
      var open = typeof force === 'boolean' ? force : this.btn.getAttribute('aria-expanded') !== 'true';
      this.btn.setAttribute('aria-expanded', String(open));
      this.classList.toggle('is-open', open);

      if (reduce) {
        p.hidden = !open;
        return;
      }
      var done = () => {
        p.style.height = '';
        if (!open) p.hidden = true;
      };
      if (open) {
        p.hidden = false;
        var h = p.scrollHeight;
        p.style.height = '0px';
        void p.offsetHeight;
        p.style.height = h + 'px';
      } else {
        p.style.height = p.scrollHeight + 'px';
        void p.offsetHeight;
        p.style.height = '0px';
      }
      clearTimeout(this._t);
      this._t = setTimeout(done, 380);
    }
  }

  customElements.define('nc-slider-nav', NcSliderNav);
})();

  } catch(e) { console.error(e); }
})();
})();
